export default "__VITE_ASSET__BOe_Q9Fk__"